
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../services/api';

const SimulationResults = () => {
  const [searchParams] = useSearchParams();
  const [log, setLog] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const simulationId = searchParams.get('id');

  useEffect(() => {
    const fetchLog = async () => {
      setLoading(true);
      setError(null);
      try {
        if (!simulationId) {
          setError('Не указан id симуляции');
          setLoading(false);
          return;
        }

        // Получаем pre-signed URL от API Gateway
        const urlResponse = await api.get(`/simulations/${simulationId}/log`);
        const presignedUrl = urlResponse.data.url;

        if (!presignedUrl) {
          setLog('Лог отсутствует');
          setLoading(false);
          return;
        }

        // Скачиваем лог напрямую из MinIO по pre-signed URL
        const logResponse = await api.get(presignedUrl, {
          responseType: 'text',
          baseURL: '',  // Отключаем baseURL для внешнего запроса
          withCredentials: false  // Не отправляем cookies
        });

        setLog(logResponse.data || 'Лог пустой');

      } catch (err) {
        console.error('Ошибка загрузки лога:', err);
        if (err.response?.status === 404) {
          setLog('Лог отсутствует');
        } else {
          setError(`Ошибка загрузки лога: ${err.message}`);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchLog();
  }, [simulationId]);

  return (
    <div className="simulation-results" style={{ padding: '2rem' }}>
      <h1>Лог симуляции</h1>
      {loading ? (
        <p>Загрузка...</p>
      ) : error ? (
        <p style={{ color: 'red' }}>{error}</p>
      ) : (
        <div style={{
          width: '100%',
          maxHeight: '600px',
          overflowY: 'auto',
          background: '#f8f8f8',
          border: '1px solid #ccc',
          padding: '16px',
          fontFamily: 'monospace',
          whiteSpace: 'pre-wrap',
        }}>
          {log}
        </div>
      )}
    </div>
  );
};

export default SimulationResults;
